<template>
  <div class="pallet-list" v-loading="loadingData">
    <div class="header-buttons" v-if="showActions">
      <el-button type="primary" plain size="mini" @click="refreshPage">
        Refresh
      </el-button>

      <el-button
        type="primary"
        plain
        size="mini"
        @click="openNewTrackRecordDialog"
      >
        New Tracking Record
      </el-button>
    </div>
    <basic-table
      :maxHeight="maxHeight"
      :table-data="recordPage"
      :table-headers="TrackingRecordTableHeaders"
      :has-actions="showActions"
      :sortChange="sortChange"
      :paginationChange="paginationChange"
      :actionWidth="actionWidth"
      :showPagination="showPagination"
      :rowClassName="rowClassName"
      :stripe="!rowClassName"
      :summary="true"
      :selectable="selectable"
    >
      <template v-slot:row-actions="props">
        <div class="actions f-r">
          <el-button
            size="small"
            type="text"
            @click="() => openTrackingRecordDialog(props.row)"
          >
            Edit
          </el-button>
          <el-button
            size="small"
            type="text"
            class="danger-text"
            @click="() => openDelete(props.row)"
          >
            Delete
          </el-button>
          <el-button
            size="small"
            type="text"
            @click="() => openFakeTraceDialog(props.row)"
          >
            Fake Trace
          </el-button>
        </div>
      </template>
      <template #[palletNosSlot]="props">
        <div class="pallet-nos-list">
          <el-tag
            v-for="palletNo in props.row.palletNos"
            :key="palletNo"
            type="success"
          >
            {{ palletNo }}
          </el-tag>
        </div>
      </template>
    </basic-table>
    <tracking-record-delete ref="deleteDialog" :successCb="refreshPage" />
    <TrackingRecordUpdate ref="trackingRecordDialog" :successCb="refreshPage" />
    <FakeTraceDialog ref="fakeTraceDialog" :successCb="refreshPage" />
  </div>
</template>
<script>
import { queryShipmentTrackingRecords } from '@/api/tracking'
import {
  Ascending,
  DefaultPageSize,
  Descending,
  PageCurrentKey,
  PageSizeKey,
  getDefaultSort
} from '@/core/configs/types'
import { TrackingRecordTableHeaders } from '@/core/models/tracking'
import { isEmpty, debounce, isEqual } from 'lodash'
import BasicTable from '../common/BasicTable.vue'
import TrackingRecordDelete from './TrackingRecordDelete.vue'
import TrackingRecordUpdate from '@/components/tracking/TrackingRecordUpdate.vue'
import FakeTraceDialog from './FakeTraceDialog.vue'

export default {
  name: 'TrackingRecords',
  components: { BasicTable, TrackingRecordDelete, TrackingRecordUpdate, FakeTraceDialog },
  props: {
    maxHeight: {
      type: Number,
      default: -1
    },
    recordQuery: {
      type: Object,
      required: true
    },
    refresh: {
      type: Boolean,
      default: false
    },
    showActions: {
      type: Boolean,
      default: true
    },
    actionWidth: {
      type: Number,
      default: 240
    },
    showPagination: {
      type: Boolean,
      default: true
    },
    rowClassName: {
      type: Function,
      default: () => {}
    },
    selectable: {
      type: Boolean,
      default: false
    },
    shipmentId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      TrackingRecordTableHeaders,
      loadingData: false,
      loadingDelete: false,
      recordList: [],
      pagination: {
        [PageSizeKey]: this.showPagination ? DefaultPageSize : -1,
        [PageCurrentKey]: 1,
        total: 0,
        asc: '',
        desc: ''
      },
      palletNosSlot: 'palletNos',
      debouncedQuery: debounce(this.fetchRecords, 300)
    }
  },
  computed: {
    recordPage() {
      return {
        records: this.recordList,
        ...this.pagination
      }
    }
  },
  watch: {
    recordQuery: {
      handler(one, two) {
        if (isEqual(one, two)) return
        this.debouncedQuery()
      },
      deep: true
    }
  },
  methods: {
    sortChange(sort) {
      if (sort.order === Ascending) {
        this.pagination.asc = sort.col
        this.pagination.desc = ''
      } else if (sort.order === Descending) {
        this.pagination.desc = sort.col
        this.pagination.asc = ''
      }
      this.debouncedQuery()
    },
    paginationChange(key, path, value) {
      this.pagination[key] = value
      this.debouncedQuery()
    },
    refreshPage() {
      this.debouncedQuery()
    },
    confirmDelete() {
      //
    },
    cancelCb() {
      //
    },
    openDelete(record) {
      this.$refs.deleteDialog.open(record)
    },
    openTrackingRecordDialog(record) {
      this.$refs.trackingRecordDialog.open(
        'Update',
        this.shipmentId,
        record.palletIds,
        record.id,
        record.quantity,
        record.weight,
        record.description
      )
    },
    openNewTrackRecordDialog() {
      this.$refs.trackingRecordDialog.open('New', this.shipmentId, [])
    },
    openFakeTraceDialog(row) {
      const fakeTrace = row.extraData?.trace ?? ''
      this.$refs.fakeTraceDialog.open(this.shipmentId, row.id, fakeTrace)
    },
    async deleteTrackingRecord() {
      //
    },
    async fetchRecords() {
      this.loadingData = true
      getDefaultSort(TrackingRecordTableHeaders, this.pagination)
      let records = []
      if (!isEmpty(this.recordQuery)) {
        records = await queryShipmentTrackingRecords(this.recordQuery)
      }
      this.$set(this, 'recordList', records)
      this.pagination.total = records.length
      this.loadingData = false
    }
  }
}
</script>
<style scoped lang="scss">
.header-buttons {
  margin-bottom: 8px;
}
.tracking-delete-dialog {
  background-color: red;
  ::v-deep .content {
    height: 10px !important;
  }
}
.pallet-nos-list {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}
</style>
